import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-898fae94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "repair-step-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, "提单", -1))
const _hoisted_3 = { class: "step-desc" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, "权益判定", -1))
const _hoisted_5 = { class: "rights-info" }
const _hoisted_6 = { class: "rights-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "rights-desc" }, " 以上为设备故障报修时设备享有的权益，不代表最终维修享受的权益。实际维修享受权益以维修定责结果为准！ ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, "已取消", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, "网点接单", -1))
const _hoisted_10 = {
  key: 0,
  class: "step-desc"
}
const _hoisted_11 = {
  key: 1,
  class: "step-desc"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, "维修方案", -1))
const _hoisted_13 = {
  key: 0,
  class: "repair-record-wrap"
}
const _hoisted_14 = {
  key: 1,
  class: "step-desc"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, "设备交付", -1))
const _hoisted_16 = {
  key: 0,
  class: "step-desc"
}
const _hoisted_17 = {
  key: 1,
  class: "step-desc"
}

import { Step, Steps } from 'vant'
import { withDefaults, computed, ComputedRef, ref, watch, nextTick } from 'vue'
import { MalfunctionRepairServiceOrderDetail } from '@/types/malfunction-repair'
import BlockkWrapper from '../block-wrap.vue'
import RepairRecord from './detail-repair-record.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'detail-repair-block',
  props: {
    detail: { default: null }
  },
  setup(__props: any) {

const props = __props as { detail: MalfunctionRepairServiceOrderDetail };



const repairOrderList: ComputedRef<any[]> = computed(() => {
  const standbyMachineList: any[] = props.detail?.standbyMachines || []
  const serviceChargeList: any[] = props.detail?.charges || []
  return (props.detail.repairs || []).concat(standbyMachineList).concat(serviceChargeList)
})
const hasRepairOrder = computed(() => {
  return !!repairOrderList.value.length
})
const isCancelOrder = computed(() => {
  return props.detail.status === 'CANCEL'
})
const isUseCancelStep = computed(() => {
  return isCancelOrder.value && (!props.detail.repairs || props.detail.repairs.length === 0)
})
// 当前进度 不能按status判断， 会有CANCEL取消状态
// 按照各阶段字段判断
const currentStep = computed(() => {
  console.log('currentStep')
  let step = 2
  if (isUseCancelStep.value) {
    return step
  }
  let detail = props.detail
  let status = detail.status
  if (status === 'END' || detail.end_at) {
    step = 4
  } else if (status === 'HANDLE_ING' || hasRepairOrder.value) {
    step = 3
  }
  return step
})
const qualityText = computed(() => {
  if (!props.detail) {
    return ''
  }
  const isQuality = props.detail.is_quality
  return `（质保期${isQuality === 1 ? '内' : '外'}）`
})
const isCompleted = computed(() => {
  let status = props.detail.status
  return status === 'END' || status === 'CANCEL'
})

let isShrink = ref(true)

let shrinkText = computed(() => {
  return isShrink.value ? '展开' : '收起'
})

function shrinkChangeHandle() {
  // 改变step样式
  if (isShrink.value) {
    //显示当前的step其他隐藏
    nextTick(() => {
      let idWrap = document.getElementById('step-wrap')
      console.log('idWrap', idWrap)
      let finishArr = idWrap.getElementsByClassName('van-step--finish')
      for (var i = 0; i < finishArr.length; i++) {
        if (i !== finishArr.length - 1) {
          finishArr[i].style.display = 'none'
        } else {
          finishArr[i].getElementsByClassName('van-step__title')[0].style.display = 'none'
          finishArr[i].getElementsByClassName('van-step__circle-container')[0].style.display =
            'none'
        }
      }
      let waitArr = idWrap.getElementsByClassName('van-step--waiting')
      for (var i = 0; i < waitArr.length; i++) {
        if (i !== 0) {
          waitArr[i].style.display = 'none'
        } else {
          waitArr[i].getElementsByClassName('van-step__title')[0].style.display = 'none'
          waitArr[i].getElementsByClassName('van-step__circle-container')[0].style.display = 'none'
        }
      }
    })
  } else {
    nextTick(() => {
      let idWrap = document.getElementById('step-wrap')
      console.log('idWrap', idWrap)
      let finishArr = idWrap.getElementsByClassName('van-step--finish')
      for (var i = 0; i < finishArr.length; i++) {
        if (i !== finishArr.length - 1) {
          finishArr[i].style.display = 'block'
        } else {
          finishArr[i].getElementsByClassName('van-step__title')[0].style.display = 'block'
          finishArr[i].getElementsByClassName('van-step__circle-container')[0].style.display =
            'block'
        }
      }
      let waitArr = idWrap.getElementsByClassName('van-step--waiting')
      for (var i = 0; i < waitArr.length; i++) {
        if (i !== 0) {
          waitArr[i].style.display = 'block'
        } else {
          waitArr[i].getElementsByClassName('van-step__title')[0].style.display = 'block'
          waitArr[i].getElementsByClassName('van-step__circle-container')[0].style.display = 'block'
        }
      }
    })
  }
}

watch(
  () => isShrink.value,
  () => {
    shrinkChangeHandle()
  },
  {
    immediate: true,
  }
)
watch(
  () => currentStep.value,
  () => {
    shrinkChangeHandle()
  }
)

function shrinkHandle() {
  isShrink.value = !isShrink.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BlockkWrapper, { title: "维修进度查询" }, {
    right: _withCtx(() => [
      _createElementVNode("div", {
        class: "shrinkText",
        onClick: shrinkHandle
      }, _toDisplayString(_unref(shrinkText)), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Steps), {
          direction: "vertical",
          active: _unref(currentStep),
          "active-color": "#00C378",
          id: "step-wrap"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Step), null, {
              default: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("p", _hoisted_3, _toDisplayString(__props.detail.created_at) + "提交了售后服务申请", 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Step), null, {
              default: _withCtx(() => [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("p", _hoisted_6, _toDisplayString(__props.detail.xcare_type_text), 1),
                  _hoisted_7
                ])
              ]),
              _: 1
            }),
            (_unref(isUseCancelStep))
              ? (_openBlock(), _createBlock(_unref(Step), { key: 0 }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_unref(Step), null, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      (__props.detail.received_at)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(__props.detail.received_at) + " " + _toDisplayString(__props.detail.repair_warehouse?.name) + "已接单 ", 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_11, "待接单"))
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Step), null, {
                    default: _withCtx(() => [
                      _hoisted_12,
                      (_unref(hasRepairOrder))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(repairOrderList), (order, index) => {
                              return (_openBlock(), _createBlock(RepairRecord, {
                                key: order.guid,
                                order: order,
                                serviceGuid: props.detail.guid,
                                servoceNo: __props.detail.service_no,
                                showBottomBorder: index !== _unref(repairOrderList).length - 1
                              }, null, 8, ["order", "serviceGuid", "servoceNo", "showBottomBorder"]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_14, "暂未开单"))
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Step), null, {
                    default: _withCtx(() => [
                      _hoisted_15,
                      (_unref(isCompleted))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(__props.detail?.end_at) + " 已交付设备", 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_17, "未交付"))
                    ]),
                    _: 1
                  })
                ], 64))
          ]),
          _: 1
        }, 8, ["active"])
      ])
    ]),
    _: 1
  }))
}
}

})